import { IComboBox, IComboBoxOption } from "@fluentui/react";
import React, { useCallback, useEffect, useRef, useState } from "react";
import listaVerificacionServicio from "../../services/ListaVerificacion/listaVerificacionServicio";
import {
  IModeloDispositovoPorPersona,
  IModeloEquipoDelete,
} from "../../Interfaces/DispositivoAsignado/IDispositivoAsignado";
import { ITablaPersonaEquipo } from "../../Interfaces/IListaVerificacion";
import { IResponseException } from "../../Interfaces/base/IBase";
import { IResponsePost } from "../../Interfaces/base/IResponse";
import { IPaginacion } from "../../Interfaces/filter";
import {
  IFilterTableAutorizacionModeloPorPersona,
  initialFilterTableAutorizacionModeloPersona,
} from "../../Interfaces/IAutorizacionModeloEquipo";

export const useComboModeloEquipos = (
  persId: string | undefined,
  isOpenPanel: boolean
) => {
  const [loading, setLoadint] = useState(false);
  const [responseDelete, setResponseDelete] = useState<IResponsePost>(null!);
  const [isSendEliminar, setIsSendEliminar] = useState(false);
  const [filterTable, setFilterTable] =
    useState<IFilterTableAutorizacionModeloPorPersona>({
      ...initialFilterTableAutorizacionModeloPersona, personaId:persId
    }
    );

  const [equipoModeloCombo, setEquipoModeloCombo] = useState<IComboBoxOption[]>(
    []
  );
  const [itemsEquipoAsignados, setItemsEquipoAsignados] = useState<
    ITablaPersonaEquipo[]
  >([]);
  const [paginacion, setPaginacion] = useState<IPaginacion>(null!);
  const onClickNext = () => {
    let valueSkip = filterTable.skip;

    setFilterTable({ ...filterTable, skip: valueSkip + 1 });
  };

  const onClickPrevius = () => {
    let valueSkip = filterTable.skip;

    setFilterTable({ ...filterTable, skip: valueSkip - 1 });
  };
  const [dataRequest, setDataRequest] = useState<IModeloDispositovoPorPersona>({
    personaId: persId,
    search: "",
  });
  const comboBoxRefModeloEquipos = useRef<IComboBox>(null);

  const onClickComboModeloEquipos = () =>
    comboBoxRefModeloEquipos.current?.focus(true);

  const _openOptionModeloEquipos = useCallback(
    () => comboBoxRefModeloEquipos.current?.focus(true),
    []
  );

  const _onkeyUpSearchModeloEquipo = (
    event: React.KeyboardEvent<IComboBox>
  ) => {
    _openOptionModeloEquipos();
    let { value } = event?.target as HTMLInputElement;
    setDataRequest({ ...dataRequest, search: value });
  };

  const postComboEquipoModelo = (data: IModeloDispositovoPorPersona) => {
    listaVerificacionServicio.allEquipoModelo(data).then((res) => {
      if (res.status === 200) {
        setEquipoModeloCombo(res.data);
      }
    });
  };
  const getDataPersonaEquipo = () => {
    setLoadint(true);
    if (persId !== undefined) {
      setFilterTable({ ...filterTable, personaId: persId });

      console.log("esta es la data de", filterTable);
      listaVerificacionServicio
        .autorizacionesPorPersona(filterTable)
        .then((res) => {
          if (res.status == 200) {
            setItemsEquipoAsignados(res.data.items);
            setPaginacion({
              page: res.data.page,
              total: res.data.total,
              pages: res.data.pages,
            });
            setLoadint(false);
          }
        })
        .catch((e) => {
          console.log(e);
          setLoadint(false);
        });
    }
  };

  const deleteModeloEquipo = (
    data: IModeloEquipoDelete,
    onDismiss: () => void
  ) => {
    setIsSendEliminar(true);
    listaVerificacionServicio
      .putEliminarModeloEquipoPersona(data)
      .then((res) => {
        if (res.status === 200) {
          setResponseDelete(res.data);
          setIsSendEliminar(false);
          getDataPersonaEquipo();
          onDismiss();
        } else {
          setIsSendEliminar(false);
          onDismiss();
        }
      });
  };
  const ocultarMensajeResponse = () => {
    setResponseDelete(null!);
  };

  useEffect(() => {
    getDataPersonaEquipo();
  }, []);

  useEffect(() => {
    if (isOpenPanel) {
      postComboEquipoModelo(dataRequest);
    }
  }, [dataRequest, isOpenPanel]);

  return {
    paginacion,
    onClickNext,
    onClickPrevius,
    postComboEquipoModelo,
    dataRequest,
    loading,
    equipoModeloCombo,
    comboBoxRefModeloEquipos,
    _onkeyUpSearchModeloEquipo,
    onClickComboModeloEquipos,
    itemsEquipoAsignados,
    responseDelete,
    isSendEliminar,
    deleteModeloEquipo,
    ocultarMensajeResponse,
    getDataPersonaEquipo,
  };
};
